module.exports = __webpack_public_path__ + "static/assets/369dbe1e3f2c6a5cbdd73b9826cec7ff.png";